import Layout from "../components/layout/layout";
import "../styles/globals.css";
import "../styles/unreset.css";


import Loader from "../components/Loader/Loader";
import ErrorBoundary from "../components/ErrorBoundary";
import AcceptCookies from "../components/acceptCookies";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { RouteGuard } from "../components/auth/RouteGuard";
import Script from "next/script";

import store from "../redux/store";
import { configuration } from "../helpers/config";
import useGoogleTranslateFix from "../hooks/useGoogleTranslateFix";

import { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import { Router } from "next/router";

import "react-toastify/dist/ReactToastify.css";

function MyApp({ Component, pageProps }) {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const mainContentRef = useRef(null);
  const [skipLinkTargetId, setSkipLinkTargetId] = useState("");
 
  useGoogleTranslateFix();

  // Focus main content if URL has #main-content
  useEffect(() => {
    if (window.location.hash === "#main-content" && mainContentRef.current) {
      mainContentRef.current.focus();
    }
  }, []);
 
  useEffect(() => {
  const handleMouseDown = () => document.body.classList.add("using-mouse");
  const handleKeyDown = (e) => {
    if (e.key === "Tab") {
      document.body.classList.remove("using-mouse");
    }
  };

  document.addEventListener("mousedown", handleMouseDown);
  document.addEventListener("keydown", handleKeyDown);

  return () => {
    document.removeEventListener("mousedown", handleMouseDown);
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);

  useEffect(() => {
  const updateSkipLinkTarget = () => {
    setTimeout(() => {
      if (document.getElementById("cta-icons-modelPage")) {
        setSkipLinkTargetId("cta-icons-modelPage");
      } else if (document.getElementById("find-perfect-suzuki")) {
        setSkipLinkTargetId("find-perfect-suzuki");
      } else {
        setSkipLinkTargetId(""); // Hide the link if no valid target
      }
    }, 100); // Give time for DOM to render
  };
 
  updateSkipLinkTarget(); // Initial run
 
  router.events.on("routeChangeComplete", updateSkipLinkTarget);
  return () => {
    router.events.off("routeChangeComplete", updateSkipLinkTarget);
  };
}, [router]);
 
   
 
  // Lowercase route enforcement
  useEffect(() => {
    const { asPath } = router;
    if (asPath !== asPath.toLowerCase()) {
      router.replace(asPath.toLowerCase());
    }
  }, [router]);

  // Route event handlers
  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => {
      setLoading(false);
      window.scrollTo(0, 0);
    };

    Router.events.on("routeChangeStart", handleStart);
    Router.events.on("routeChangeComplete", handleComplete);
    Router.events.on("routeChangeError", handleComplete);

    return () => {
      Router.events.off("routeChangeStart", handleStart);
      Router.events.off("routeChangeComplete", handleComplete);
      Router.events.off("routeChangeError", handleComplete);
    };
  }, []);

  // Accept cookies logic cleanup
  const showCookies =
    (!configuration.COOKIEBOT.includes(configuration.COUNTRY_CODE) &&
      !configuration.ENSIGHTEN.includes(configuration.COUNTRY_CODE)) ||
    (configuration.COOKIEBOT.includes(configuration.COUNTRY_CODE) &&
      configuration.ENSIGHTEN.includes(configuration.COUNTRY_CODE));

  const AppContent = (
    <>
        {skipLinkTargetId && (
        <a href={`#${skipLinkTargetId}`} className="skip-link"
        onFocus={() => {
          document.body.classList.add('skip-visible');
        }}
        onBlur={() => {
          document.body.classList.remove('skip-visible');
        }}>
      Skip to Main Content
    </a>
  )}
      <Layout menu={pageProps?.Menudata} footer={pageProps?.Footerdata}>
        {/* Main content with focusable area */}
        <div id="main-content" ref={mainContentRef} tabIndex={-1}>
          <Component {...pageProps} />
        </div>
      </Layout>
    </>
  );

  return (
    <ErrorBoundary>
      <ToastContainer />
      {loading && <Loader centerMode />}

      <Provider store={store}>
        {configuration.IS_ROUTE_GUARD_IMPLENTED === "true" ? (
          <RouteGuard>{AppContent}</RouteGuard>
        ) : (
          AppContent
        )}

        {showCookies && <AcceptCookies />}

        {/* SPH GOOGLE ADS MANAGER */}
        {configuration?.COUNTRY_CODE === "PH" && (
          <>
            <Script
              async
              src="https://www.googletagmanager.com/gtag/js?id=AW-16800370186"
              strategy="afterInteractive"
            />
            <Script id="google-analytics" strategy="afterInteractive">
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-16800370186');
              `}
            </Script>
                        {/* meta pixel code */}
                        <script
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '338296281964137');
            fbq('track', 'PageView');
          `,
        }}
      />
            
            { typeof window !== 'undefined' &&  window.location.pathname == "/pages/thank-you-get-quote" &&  <>   <Script
        id="facebook-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '338296281964137'); 
            fbq('track', 'PageView');
            fbq('track', 'Lead');
          `,
        }}
      />

</>
      }
      
          </>
        )}
      </Provider>
    </ErrorBoundary>
  );
}

export default MyApp;
